import * as api from "Api";

class CapacityPlaningApi {
  getCapacityPlaningCollaboratorChart(
    id,
    collaboratorUid,
    erpId,
    period,
    year,
    isCumulate,
    date
  ) {
    return api
      .getCollaboratorCapacityPlaningChart(
        id,
        collaboratorUid,
        erpId,
        period,
        year,
        isCumulate,
        date
      )
      .then(response => response.data.data);
  }
}

export default new CapacityPlaningApi();



// WEBPACK FOOTER //
// ./src/services/capacityPlaningServices.js